import type { ConceptDef } from '../types';

export const sequenceSizeOrder: ConceptDef = {
  kind: 'sequenceTap',
  id: 'sequence-size-order',
  label: 'Sequence Size Order',
  category: 'Sequencing',
  description: 'Tap items from smallest to biggest.',
  config: {
    promptMode: 'AUDIO',
    sequences: [
      { label: 'Smallest to biggest.', items: ['🐜 ant', '🐁 mouse', '🐶 dog', '🐎 horse', '🐘 elephant'] },
    ],
  },
};
